<ng-container [ngSwitch]="column.template||column.name">

    <ng-container *ngSwitchCase="'correlationLink'">
    <a *ngIf="record[column.name]" href="javascript:false;" (click)="showCorrelation($any(record))" class="text-nowrap">
        {{record[column.name]|date:'yyyy-MM-dd HH:mm:ss':'UTC'}}
    </a>
    </ng-container>

    <ng-container *ngSwitchCase="'user'">
        <a *ngIf="record[column.name]" href="javascript:false;" (click)="editUser($any(record))" class="text-nowrap">
            {{record[column.name]}}
        </a>
    </ng-container>

    <ng-container *ngSwitchCase="'sourceid'">
        <a *ngIf="record[column.name] && (record.testtype=='rut' || record.testtype=='dialer') else notSupportedTestType" href="javascript:false;" (click)="showCall($any(record))" class="text-nowrap">
            {{record[column.name]}}
        </a>
        <ng-template #notSupportedTestType>
            {{record[column.name]}}
        </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="'taskid'">
        <a *ngIf="record[column.name] else noTaskId" href="javascript:false;" (click)="showTask($any(record))" class="text-nowrap">
            {{record[column.name]}}
        </a>
        <ng-template #noTaskId>
        <div class="text-center">
        <a *ngIf="record.testtype=='dialer'" href="javascript:false;" (click)="showTask($any(record))"
        class="text-center">
            <i class="fa fa-search"></i>
        </a>
    </div>
        </ng-template>
    </ng-container>

    <ng-container *ngSwitchCase="'testpointid'">
        <a *ngIf="record[column.name]" href="javascript:false;" (click)="showTestPoint($any(record))" class="text-nowrap">
            {{record[column.name]}}
        </a>
    </ng-container>

    <div *ngSwitchDefault fes-table-view-default-cell-renderer
        [column]="column"
        [record]="record"
        [tableComponent]="tableComponent"
    >
    </div>

</ng-container>

